<template>
    <div class="pdf__flats-list">
        <div class="pdf__flats-header">
            <div class="pdf__flats-header-title">
                {{ complex }}
            </div>
            <a
                class="pdf__flats-header-link"
                :href="`https://${url}`"
                target="_blank">
                {{ url }}
            </a>
        </div>
        <div
            v-for="flat in flats"
            :key="flat.id"
            class="pdf__flat">
            <div class="pdf__flat-image">
                <template v-if="flat.image && Array.isArray(flat.image)">
                    <div
                        v-for="(image, index) in flat.image"
                        :key="index"
                        class="pdf__flat-image-wrapper">
                        <img
                            :src="image"
                            alt="описание">
                    </div>
                </template>
                <template v-else-if="flat.image">
                    <div class="pdf__flat-image-wrapper">
                        <img
                            :src="flat.image"
                            :alt="flat.name">
                    </div>
                </template>
            </div>
            <div class="pdf__flat-description">
                <div class="pdf__flat-main">
                    <div class="pdf__flat-main-info">
                        {{ flat.complex }}
                        <span>{{ flat.number }}</span>
                    </div>
                    <div class="pdf__flat-main-name">
                        {{ flat.name }}
                    </div>
                </div>
                <div class="pdf__flat-props">
                    <div class="pdf__flat-props-block">
                        <div
                            v-for="prop in flat.propsTop"
                            :key="prop"
                            class="pdf__flat-props-item">
                            {{ prop }}
                        </div>
                    </div>
                    <div class="pdf__flat-props-block">
                        <div
                            v-for="prop in flat.propsBottom"
                            :key="prop"
                            class="pdf__flat-props-item">
                            {{ prop }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="pdf__flat-price">
                <div
                    v-if="flat.priceOld"
                    class="pdf__flat-price-old">
                    <div class="pdf__flat-price-old-value">
                        {{ flat.priceOld }}
                    </div>
                    <div
                        v-if="flat.salePercent"
                        class="pdf__flat-price-old-percent">
                        {{ flat.salePercent }}
                    </div>
                </div>
                {{ flat.price }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PdfGroup',

    props: {
        complex: {
            type    : String,
            required: true
        },
        url: {
            type    : String,
            required: true
        },
        flats: {
            type    : Array,
            required: true
        }
    }
};
</script>